import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { itemCategoryService } from "@project/services/admin/item-category.service";
import {
  ITEM_CATEGORY_TYPE_OPTIONS,
  type ItemCategoryPayload,
  type ItemCategoryRecord,
  type ItemCategoryType,
} from "@project/types/item-category";

const fields: Field[] = [
  {
    name: "item_category_type",
    label: "Donation Type",
    type: "select",
    required: true,
    showInTable: true,
    placeholder: "Select type",
    options: ITEM_CATEGORY_TYPE_OPTIONS,
  },
  {
    name: "name",
    label: "Category Name",
    required: true,
    showInTable: true,
    placeholder: "Medical Supplies",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    showInTable: true,
    placeholder: "Medicines, bandages, and daily care items.",
  },
  {
    name: "is_active",
    label: "Status",
    type: "boolean",
    showInTable: true,
  },
];

function toPayload(payload: Record<string, unknown>): ItemCategoryPayload {
  return {
    item_category_type: String(
      payload.item_category_type ?? ""
    ) as ItemCategoryType,
    name: String(payload.name ?? "").trim(),
    description: payload.description
      ? String(payload.description).trim()
      : undefined,
    is_active: payload.is_active === true || payload.is_active === "true",
  };
}

export default function Page() {
  return (
    <AdminShell
      title="Item Categories"
      subtitle="Manage in-kind and scrap donation item categories shown on public donation forms"
    >
      <ApiResourceTable<ItemCategoryRecord>
        title="Item Category"
        labelField="name"
        fields={fields}
        searchFields={["name", "description", "item_category_type"]}
        defaultValues={{ is_active: true, item_category_type: "in-kind" }}
        statusFilterOptions={[
          { value: "active", label: "Active" },
          { value: "inactive", label: "Inactive" },
        ]}
        lookupOptions={{
          item_category_type: ITEM_CATEGORY_TYPE_OPTIONS,
        }}
        list={query => itemCategoryService.listPage(query)}
        create={payload => itemCategoryService.create(toPayload(payload))}
        update={(id, payload) =>
          itemCategoryService.update(id, toPayload(payload))
        }
        remove={id => itemCategoryService.delete(id)}
      />
    </AdminShell>
  );
}
